import { useState } from "react";
import { Button, LoadingSpinner } from "../../components/BaseComponents";
import CanonicalModal from "../../components/BaseComponents/CanonicalModal/CanonicalModal";
import CurrencyInput from "../../components/BaseComponents/Forms/CurrencyInput";
import Input from "../../components/BaseComponents/Forms/Input";
import Label from "../../components/BaseComponents/Label";
import useApi from "../../hooks/useApi";
import { currencyToCents, getCSRFToken } from "../../lib/utils";

type CompanyProjectCreateModalProps = {
    open: boolean;
    onClose: () => void;
}

function CompanyProjectCreateModal({open, onClose}: CompanyProjectCreateModalProps) {
    const [loading, setLoading] = useState(false);
    const api = useApi();

    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [turnover, setTurnover] = useState(0);

    const reset = () => {
        setName('');
        setCode('');
        setTurnover(0);
    };

    const onCreate = async () => {
        setLoading(true);
        await api.post('/projects', {
            name,
            code,
            totalTurnoverAmount: turnover,
            _csrf: await getCSRFToken(),
        });
        setLoading(false);
        reset();
        onClose();
    }

    return (
        <CanonicalModal
            open={open}
            onClose={() => { reset(); onClose(); }}
            size="small"
            title="Create Project"
            actions={
                <>
                    <Button onClick={onCreate} additionalClass="mr-5" disabled={!name || !code} type="Primary" text="Create" />
                    <Button onClick={onClose} type="Outlined" text="Cancel" />
                </>
            }
        >
            { loading ? <LoadingSpinner /> : (
                <form>
                    <Input
                        label="Project name"
                        name="name"
                        type="text"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        additionalClass="mt-8"
                    />
                    <Input
                        label="Unique project code"
                        name="code"
                        type="text"
                        value={code}
                        onChange={e => setCode(e.target.value)}
                        additionalClass="mt-8"
                    />
                    <div className="mt-8">
                        <Label className="block">Project value (total sales/revenues)</Label>
                        <CurrencyInput name="turnover" onChange={value => setTurnover(currencyToCents(value))} />
                    </div>
                </form>
            )}
        </CanonicalModal>
    )
}

export default CompanyProjectCreateModal;
